import { forwardRef, type ComponentPropsWithoutRef, type FC } from 'react';
import { cn } from 'src/utils/cn';

// "3fr minmax(0, 7fr)" prevents form fields from overflowing.
// "30% 70%" does not work exactly the same as the form fields could bleed into the padding of a parent component.
export const fieldLayoutGridTemplateColumns = '3fr minmax(0, 7fr)';
export const fieldLayoutGridTemplateColumnsClass =
  'grid-cols-[3fr_minmax(0,7fr)]';

type FieldLayoutProps = {
  stacked?: boolean;
  inline?: boolean;
} & ComponentPropsWithoutRef<'div'>;

export const FieldLayout: FC<FieldLayoutProps> = ({
  stacked,
  inline,
  ...props
}) => {
  return (
    <div
      {...props}
      className={cn(
        inline ? 'inline-grid' : 'grid',
        'gap-[0.5rem]',
        stacked
          ? 'grid-flow-row'
          : // in firefox "align-items: baseline;" did not work well for our current
            // textarea component, so we need to use "align-items: flex-start;" for every
            // field. this is not super accurate, but okay.
            `
              grid-flow-col
              ${fieldLayoutGridTemplateColumnsClass}
              items-baseline
              firefox:items-start
            `,
        props.className
      )}
    />
  );
};

export const FieldItem = forwardRef<
  HTMLDivElement,
  ComponentPropsWithoutRef<'div'>
>((props, ref) => {
  return (
    <div
      ref={ref}
      {...props}
      className={cn('items-baseline', props.className)}
    />
  );
});
